import React from "react";
import { Cintillo } from "@atresmedia/elections_modules_library";
import FlagGalicia from "@atresmedia/elections_modules_library/dist/assets/Flag_of_Galicia-small.png";
import FlagEuskadi from "@atresmedia/elections_modules_library/dist/assets/Flag_of_euskadi-small.png";

export const CintilloGallego = ({ rightSide }) => (
  <Cintillo
    title="GALICIA"
    backgroundColor="#00cadf"
    rightSide={rightSide}
    imgProps={{ src: FlagGalicia, alt: "Bandera de Galicia" }}
  />
);
export const CintilloVasco = ({ rightSide }) => (
  <Cintillo
    title="PAÍS VASCO"
    backgroundColor="#00ae16"
    rightSide={rightSide}
    imgProps={{
      src: FlagEuskadi,
      alt: "Bandera de País Vasco"
    }}
  />
);

export default {
  R12: CintilloGallego,
  R16: CintilloVasco
};
